import { ButtonProps } from '@shared/ui/kit/button/model/types';
import { palette } from '@shared/tokens/palette.stylex';
import { Button } from '@shared/ui/kit';
import stylex from '@stylexjs/stylex';
import { styles } from './styles';
import { FC } from 'react';

export const BasicButton: FC<ButtonProps> = ({ children, onClick, settings }, props) => {
  return (
    <Button
      onClick={onClick}
      settings={{ padding: '0 24px 0 24px', background: palette.greyBlack, ...settings }}
      {...props}
    >
      <div {...stylex.props(styles.button)}>{children}</div>
    </Button>
  );
};
